"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_FIELD_INPUT_SCHEMA_ID = void 0;
exports.DOCUMENT_FIELD_INPUT_SCHEMA_ID = '/schemas/documents';
